import {
    APP_BOOTED,
    APP_BOOTING,
    APP_BOOTSTRAP,
    APP_CLEAR_FATAL_ERROR,
    APP_LOAD_INIT_VALUES,
    APP_LOAD_REQUIRES,
    APP_LOADED,
    APP_LOADING,
    APP_SET_FATAL_ERROR,
    APP_SET_WORK_SCHEDULE,
} from './constants';
import {IReduxAppState} from '@src/@interfaces';

export const appBootstrap = () => ({type: APP_BOOTSTRAP});
export const setBooting = () => ({type: APP_BOOTING});
export const setBooted = () => ({type: APP_BOOTED});

export const appLoadInitValues = () => ({type: APP_LOAD_INIT_VALUES});

export const appLoadRequires = () => ({type: APP_LOAD_REQUIRES});
export const setLoading = () => ({type: APP_LOADING});
export const setLoaded = () => ({type: APP_LOADED});

export const setFatalError = (error: Error) => ({
    type: APP_SET_FATAL_ERROR,
    payload: error,
});
export const clearFatalError = () => ({type: APP_CLEAR_FATAL_ERROR});

export const setWorkSchedule = (schedule: IReduxAppState['workSchedule']) => ({
    type: APP_SET_WORK_SCHEDULE,
    payload: {schedule},
});
